import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Today from "./Today"; // Component for the "Today" tab
import History from "./History"; // Component for the "History" tab
import organizationLogo from './assets/school-logo.png';

const EmployeeHomePage = ({ onLogin }) => {
  const [user_id, setuser_id] = useState(null);
  const [activeTab, setActiveTab] = useState("Today"); // State to track the active tab
  const navigate = useNavigate();

  useEffect(() => {
    // Check if user_id exists in localStorage when the component mounts
    const storeduser_id = localStorage.getItem("user_id");
    if (storeduser_id) {
      setuser_id(JSON.parse(storeduser_id)); // Set user_id from localStorage
    } else {
      navigate("/organization/login"); // Redirect to login if no user_id is found
    }
  }, [navigate]);

  // Render component based on the active tab
  const renderComponent = () => {
    switch (activeTab) {
      case "Today":
        return <Today user_id={user_id} />;
      case "History":
        return <History user_id={user_id} />;
      default:
        return null;
    }
  };

  if (!user_id) {
    return null; // Do nothing if user_id is missing
  }

  return (
    <div style={{ display: "flex", width: "100vw" }}>
      <div style={{ width: "20%", backgroundColor: "#C5E2FC", height: activeTab === 'Today' ? '72vh' : 'auto' }}>
        <div style={{ display: 'flex', flexDirection: 'column', margin: '4vh auto', paddingLeft: '20px' }}>
          <img src={organizationLogo} alt='Employee' width='100' height='100' />
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              marginTop: "4vh",
              gap: "1vh",
              marginLeft: '30px'
            }}
          >
            <p
              style={{ fontSize: '14px', fontWeight: '400', lineHeight: '20px', color: activeTab==='Today'?'#ffffff':'#000000', cursor: "pointer" }}
              onClick={() => setActiveTab("Today")}
            >
              
              Today
            </p>
            <p
              style={{ fontSize: '14px', fontWeight: '400', lineHeight: '20px',  color: activeTab==='History'?'#ffffff':'#000000', cursor: "pointer" }}
              onClick={() => setActiveTab("History")}
            >
              History
            </p>
          </div>
        </div>
      </div>
      <div className="main-content" style={{ width: "78%" ,backgroundColor:'#ffffff'}}>
        {renderComponent()}
      </div>
    </div>
  );
};

export default EmployeeHomePage;
